import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import type { CatalogLadle } from "../../../models/CatalogLadle";
import { useCatalogLadleContext } from "../context/CatalogLadleContext";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  setLadle: (ladle: CatalogLadle) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  setLadle,
  setShowModal,
  showContextMenu,
}: Props) => {
  const { state } = useCatalogLadleContext();

  const rows: CatalogLadle[] =
    state.ladles?.map((ladle: CatalogLadle) => ({
      ...ladle,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "LadleName",
      headerName: "Name",
      flex: 1,
      filter: false,
      autoHeaderHeight: true,
      cellStyle: cellStyle,
    },
    {
      field: "Enabled",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setLadle,
        data: params.data as CatalogLadle,
        setShowModal: setShowModal,
        showContextMenu: () =>
          showContextMenu(event, params.data, "ladleContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 330,
      filter: false,
      autoHeaderHeight: true,
    },
  ];
  return { rows, columnDefs };
};
